import React from "react";
import { Box } from "@chakra-ui/react";

import ConditionTitle from "../ConditionTitle";
import AndOrContainer from "../../AndOrGrouping/AndOrContainer";
import { useAppSelector } from "../../../../../app/hooks";
import { selectAppState } from "../../../../../app/slice/appSlice";

const AddConditionView = () => {

  const { isMobile } = useAppSelector(selectAppState)

  return (
    <Box p={isMobile ? 0 : 4} height="100%" overflowY="auto">
      <ConditionTitle />
      <AndOrContainer />
    </Box>
  );
};

export default React.memo(AddConditionView);
